export default interface ISourceFormData {
  isEditMode: boolean;
  requestId: string;
  id: string;
  name: string;
  description: string;
  code: string;
  width: number;
  formLoading?: boolean;
  stripLength?: number;
}

export class SourceFormData implements ISourceFormData {
  isEditMode: boolean;
  requestId: string;
  id: string;
  name: string;
  description: string;
  code: string;
  width: number;
  stripLength: number;

  constructor(
    isEditMode: boolean,
    requestId: string,
    id: string,
    name: string,
    description: string,
    code: string,
    width: number,
    stripLength:number
  ) {
    this.isEditMode = isEditMode;
    this.requestId = requestId;
    this.id = id;
    this.name = name;
    this.description = description;
    this.code = code;
    this.width = width;
    this.stripLength = stripLength;
  }
}
